<template>
  <component :is="way" :vacancy-id="vacancyId" />
</template>

<script>
import { mapGetters } from 'vuex';
import PROCESS_NAMES from '@/process/names';
import basic from '@/routes_new/inner/vacancy/basic/default';
// import schlum from './schlum.vue';
const innerjti = () => import(/* webpackChunkName: "innerjti" */ '@/process/innerjti/components/vacancy/index.vue');
const feniche = () => import(/* webpackChunkName: "feniche" */ '@/process/feniche/common/components/vacancy/index.vue');
const Nmg = () => import(/* webpackChunkName: "nmg" */ '@/process/nmg/components/vacancy/index.vue');
const SiburStajirovki = () =>
  import(/* webpackChunkName: "sibur-stajirovki" */ '@/process/sibur-stajirovki/components/vacancy/basic/index.vue');
const Alrosa = () =>
  import(/* webpackChunkName: "alrosa" */ '@/process/alrosa/routes_new/inner/vacancy/AlrosaBasicVacancy');

export default {
  name: 'VacancyBasicIndex',

  components: {
    default: basic,
    // schlum,
    innerjti,
    feniche,
    Nmg,
    SiburStajirovki,
    Alrosa
  },

  beforeRouteUpdate(to, from, next) {
    let c = true;

    if (this.has_changes) {
      c = confirm(this.$tr('vacancy.preferences.modals.leaveUnsavedData'));
      if (!c) {
        next(false);
        return false;
      }
    }

    next();
  },

  beforeRouteLeave(to, from, next) {
    let c = true;

    if (this.has_changes) {
      c = confirm(this.$tr('vacancy.preferences.modals.leaveUnsavedData'));
      if (!c) {
        next(false);
        return false;
      }
    }

    next();
  },

  props: ['vacancyId'],

  computed: {
    ...mapGetters('vacancy_new', ['companyId']),

    ...mapGetters('process', ['getProcessName']),

    has_changes() {
      return this.$store.getters['vacancy/change'];
    },

    isSiburCompany() {
      // На вакансии может быть не активирован спецпроцесс, поэтому мы цепляемся к айди вакансии.
      const vacancy = this.$store.getters['vacancy/one'];
      return vacancy && this.companyId == 87; // не строгое равенство потому что часть айдишников получаем строками
    },

    way() {
      if (
        // this.getProcessName === PROCESS_NAMES.SCHLUMBERGER ||
        this.getProcessName === PROCESS_NAMES.JTI_INNER ||
        this.getProcessName === PROCESS_NAMES.NMG ||
        this.getProcessName === PROCESS_NAMES.FENICHE ||
        this.getProcessName === PROCESS_NAMES.ALROSA ||
        this.getProcessName === PROCESS_NAMES.SIBUR_INTERNSHIPS
      ) {
        return this.getProcessName;
      } else if (this.isSiburCompany) {
        return PROCESS_NAMES.SIBUR_INTERNSHIPS;
      } else if (this.getProcessName === PROCESS_NAMES.BAT_PERSONAL_ACCOUNT) {
        return 'bat';
      } else {
        return 'default';
      }
    }
  },

  created() {
    this.$emit('loaded', { key: 'set_current_page_id', v: 'basic' });
  }
};
</script>
